<template>
  <Head title="Servicevoorwaarden">
    <meta
      name="description"
      content="Dit zijn de leveringsvoorwaarden van ShoutOut. Lees ze goed door zodat je weet waar je aan toe bent."
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.terms-and-conditions')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="content-hero py-20 relative overflow-hidden">
    <img
      class="absolute top-0 left-0 lg:hidden"
      src="/frontend/assets/mobile-hero-swirl.svg"
    >
    <img
      class="absolute top-0 left-0 hidden lg:block"
      src="/frontend/assets/desktop-hero-swirl.svg"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          Service voorwaarden
        </h1>
      </div>
    </div>
  </section>

  <section class="content text-lg py-20 relative bg-white">
    <img
      class="hidden lg:block absolute left-0 top-[400px]"
      src="/frontend/assets/scribble-round-desktop.svg"
    >

    <div class="container">
      <h2 class="font-bold pb-2">
        Algemene Voorwaarden ShoutOut VIP B.V. – voor het laatst herzien op april 2022 -
      </h2>
      <p class="italic">
        In deze algemene voorwaarden wordt verstaan onder:<br>
        <strong>Wij, we, ons of onze:</strong> ShoutOut VIP B.V., gevestigd aan de Wingerdweg 229, 1032 AH in Amsterdam, ingeschreven bij de
        Kamer van Koophandel onder registratienummer 78153034 en met Btw-identificatienummer: 861282474B01. Emailadres: <a
          class="text-blue underline"
          href="mailto:hi@shoutout.vip"
        >hi@shoutout.vip</a>.<br>
        <strong>Klant, jij, je of jou(w):</strong> De aanvrager van een ShoutOut en/of de bezoeker van onze website(s).<br>
        <strong>ShoutOut:</strong> De persoonlijke videoboodschap die is gemaakt door de VIP van jouw keuze.<br>
        <strong>Voorwaarden:</strong> deze algemene voorwaarden.<br>
        <strong>VIP:</strong> Het idool van wie je een ShoutOut kan aanvragen op onze website www.shoutout.vip.<br>
      </p>
      <h3 class="font-bold pb-2">
        1. Toepasselijkheid
      </h3>
      <p>
        Deze Voorwaarden zijn van toepassing op iedere bestelling van een ShoutOut of op jouw bezoek aan onze website
        www.shoutout.vip. Daarnaast zijn deze Voorwaarden van toepassing op al onze andere diensten, leveringen en
        aanbiedingen en op overeenkomsten die je met ons afsluit.
      </p>
      <p>
        Wij kunnen deze Voorwaarden zo nu en dan wijzigen. Op onze website zijn altijd de meest recente Voorwaarden te
        vinden. We raden je daarom aan om regelmatig op onze website te checken of er nieuwe Voorwaarden gelden. Natuurlijk
        blijven op de door jou aangevraagde ShoutOut de Voorwaarden van kracht die je bij het plaatsen van je bestelling hebt
        geaccepteerd.
      </p>
      <h3 class="font-bold pb-2">
        2. ShoutOut aanvragen
      </h3>
      <p>
        Voor het aanvragen van een ShoutOut op onze website moet je minimaal 18 jaar zijn. Ben je geen 18 jaar, dan heb je
        toestemming nodig van je wettelijke vertegenwoordiger.
      </p>
      <p>Een overeenkomst tussen jou en ons komt tot stand zodra:</p>
      <ul class="list-disc pb-2 ml-6">
        <li>je de VIP van jouw keuze hebt geselecteerd op onze website;</li>
        <li>je alle vragen en jouw gegevens hebt ingevuld;</li>
        <li>je akkoord bent gegaan met de Voorwaarden;</li>
        <li>je jouw aanvraag bevestigt via de knop ‘BOEKEN’- ; en</li>
        <li>je hebt betaald voor je ShoutOut.</li>
      </ul>
      <p>Het is jouw verantwoordelijkheid om ervoor te zorgen dat:</p>
      <ul class="list-disc pb-2 ml-6">
        <li>jouw gegevens bij de aanvraag naar waarheid zijn ingevuld;</li>
        <li>jouw aanvraag geen inbreuk maakt op of misbruik maakt van rechten van anderen of hiertoe aanzet;</li>
        <li>jouw aanvraag niet in strijd is met of aanzet tot overtreding van de wet, of op een andere manier onfatsoenlijk, beledigend, intimiderend, racistisch of aanstootgevend kan zijn.</li>
      </ul>

      <h3 class="font-bold pb-2">
        3. Prijs en betaling
      </h3>
      <p>
        De prijs voor een ShoutOut is afhankelijk van de VIP en wordt weergegeven op de profielpagina van de VIP op onze
        website. We kunnen de prijs voor een ShoutOut op elk moment wijzigen. Zodra je jouw ShoutOut boekt en hebt betaald
        kan de prijs voor de door jou geboekte ShoutOut niet meer gewijzigd worden.
      </p>
      <p>
        Nadat je je bestelling hebt bevestigd via de knop ‘BOEKEN’ word je automatisch doorgeleid naar de betaalomgeving waar
        je je betaling kan afronden.
      </p>
      <h3 class="font-bold pb-2">
        4. Herroepingsrecht / ontbinding
      </h3>
      <p>
        Omdat de ShoutOut specifiek voor jou wordt gemaakt, geldt het wettelijke herroepingsrecht niet. Dat betekent dus dat je
        de ShoutOut niet kan annuleren of ruilen. Door je bestelling te bevestigen door op de knop ‘BOEKEN’ te klikken doe je
        afstand van je herroepingsrecht en je recht op ontbinding. Het is dan ook niet meer mogelijk om je aanvraag aan te
        passen. Natuurlijk mag je wel annuleren als de ShoutOut niet binnen 7 dagen wordt opgeleverd (of binnen 48 uur bij 48-
        uur VIPS). Meer informatie hierover vind je onderaan het document.
      </p>
      <h3 class="font-bold pb-2">
        5. Inhoud ShoutOut
      </h3>
      <p>
        Bij de bestelling van de ShoutOut vul je in voor wie de ShoutOut is bestemd en welke boodschap je de VIP wil laten
        vertellen. De VIP bepaalt naar eigen inzicht hoe aan jouw verzoek wordt voldaan en hoe de ShoutOut wordt gemaakt.
        Aanvragen voor specifieke handelingen of gedicteerde teksten hoeven dus niet letterlijk overgenomen te worden door de
        VIP.
      </p>
      <h3 class="font-bold pb-2">
        6. Levering
      </h3>
      <p>
        Jouw ShoutOut wordt per e-mail en sms geleverd door een link naar een unieke landingspage. Via deze link kun je de
        ShoutOut o.a. downloaden op je eigen device.
      </p>
      <p>
        De meeste ShoutOuts worden gemiddeld 48 uur na het plaatsen van de bestelling opgeleverd. Maar let op: dit kunnen we
        niet garanderen. Het kan tot maximaal 7 dagen duren. Een aantal VIP’s biedt de mogelijkheid om binnen 48 uur een
        ShoutOut af te leveren. Dat is aangegeven op onze website bij de desbetreffende VIP’s.
      </p>
      <p>
        Let op: de VIP bepaalt zélf of jouw aanvraag wordt geaccepteerd of geweigerd. Natuurlijk maken wij er onze topprioriteit
        van dat elke klant zijn of haar bestelde ShoutOut ontvangt. Maar dit kunnen we helaas niet garanderen.
      </p>
      <p>
        Mocht je je ShoutOut niet op dag 7 (of op dag 3 bij de 48-uurs VIP’s) hebben ontvangen, dan kan jouw aanvraag worden
        geannuleerd door zowel jou als door ons. In dat geval nemen wij contact met je op om tot een oplossing te komen. Eén
        van de door ons aangeboden oplossingen is in elk geval de terugbetaling van het door jou betaalde bedrag. Hoewel we
        ons best zullen doen om met jou tot een passende oplossing te komen, kunnen wij nooit worden verplicht tot iets anders
        of meer dan de vergoeding van het door jou betaalde bedrag voor de desbetreffende ShoutOut.
      </p>
      <h3 class="font-bold pb-2">
        7. Gebruik van de ShoutOut
      </h3>
      <p>
        <span class="italic">Persoonlijk gebruik</span><br>
        De ShoutOut die je ontvangt blijft eigendom van de VIP die de ShoutOut heeft gemaakt. Jij, als aanvrager, krijgt een nietexclusieve, herroepelijke persoonlijke licentie voor niet-commerciële en niet-promotionele doeleinden om de ShoutOut
        te bekijken en te delen. Je mag de ShoutOut alleen in ongewijzigde vorm delen met je vrienden en met degene voor wie
        je de ShoutOut hebt besteld. Het op een andere manier gebruiken, openbaar maken of verveelvoudigen is uitdrukkelijk
        <strong>niet</strong> toegestaan. Het is dus verboden om een ShoutOut (of fragmenten daarvan):
      </p>
      <ul class="list-disc pb-2 ml-6">
        <li>
          te gebruiken voor commerciële of promotionele doeleinden, dus bijvoorbeeld voor de promotie van een bedrijf,
          een product of een dienst. Je mag de ShoutOut wel delen met je vrienden via je persoonlijke social media
          account;
        </li>
        <li>
          aan te passen, op welke manier dan ook. Je mag de ShoutOut dus bijvoorbeeld niet inkorten, opknippen, of
          opnieuw compileren.
        </li>
        <li>te verkopen of een sublicentie op de ShoutOut te verstrekken.</li>
      </ul>
      <p>
        Op elke Shoutout is het ShoutOut-watermerk aangebracht. Het is niet toegestaan om het Shout-Out-watermerk te
        verwijderen of aan te passen.
      </p>

      <p>
        Als er in strijd met deze Voorwaarden wordt gehandeld, dan vervalt de licentie voor de ShoutOut met onmiddellijke
        ingang. Alle kopieën in jouw bezit of beheer moeten dan direct worden verwijderd, ook van social media platforms.
      </p>
      <p>
        <span class="italic">Gebruik door ons</span>
        Wij mogen de door jou aangevraagde ShoutOut (of fragmenten daarvan) gebruiken voor promotionele doeleinden.
        Natuurlijk begrijpen we dat je iemand wil verrassen met jouw ShoutOut. Daarom zullen we een ShoutOut niet gebruiken
        binnen een maand nadat jouw ShoutOut is opgeleverd. Als je niet wil dat jouw ShoutOut voor promotionele doeleinden
        wordt gebruikt, dan kun je dat bij jouw aanvraag aangeven door een vinkje te zetten bij: “Deze video niet publiek delen
        op ShoutOut.vip”.
      </p>
      <p>
        <span class="italic">Bewaartermijn</span><br>
        Iedere ShoutOut worden 6 maanden vanaf levering bewaard in onze cloud-omgeving. Na 6 maanden kunnen wij de
        ShoutOut verwijderen. We kunnen de ShoutOut eerder verwijderen als de ShoutOut niet wordt gebruikt in
        overeenstemming met deze Voorwaarden of als de VIP de verstrekte licentie intrekt. Na verwijdering is jouw ShoutOut
        niet meer beschikbaar via de door jou ontvangen link.
      </p>
      <h3 class="font-bold pb-2">
        8. De website
      </h3>
      <p>
        Alle onderdelen van onze website, waaronder logo’s, teksten, afbeeldingen, video’s, geluid, muziek etc., zijn eigendom
        van ons of aan ons in licentie gegeven. Zonder onze voorafgaande uitdrukkelijke toestemming mag geen enkel onderdeel
        van onze website worden gekopieerd, gereproduceerd of verspreid.
      </p>
      <h3 class="font-bold pb-2">
        9. Gebruik inzendingen
      </h3>
      <p>
        We vinden het heel leuk als je feedback, foto’s, filmpjes en dergelijke (“Inzending”) met ons deelt over jouw ShoutOut, de
        reactie van de ontvanger op jouw ShoutOut of jouw ervaring met het gebruik van onze website. Door het delen van een
        Inzending geef je ons het recht om jouw Inzending zonder enige beperking te gebruiken en publiekelijk (zoals op social
        media) te delen, bijvoorbeeld voor marketing-en promotionele doeleinden of voor de verbetering van onze diensten.
      </p>
      <p>
        Het is belangrijk dat degenen die hebben bijgedragen aan jouw Inzending, of die zichtbaar zijn in de Inzending, hier ook
        mee instemmen. Dat is jouw verantwoordelijkheid. ShoutOut is niet verantwoordelijk of aansprakelijk voor enig gebruik
        of openbaarmaking van een Inzending, inclusief persoonlijke informatie van, of toebehorend aan, jou of een derde partij.
      </p>
      <h3 class="font-bold pb-2">
        10. Aansprakelijkheid
      </h3>
      <p>
        De ShoutOuts, onze website en onze andere uitingen zijn met de grootst mogelijke zorg samengesteld. Het kan echter
        voorkomen dat hier een foutje in is geslopen. Hiervoor zijn wij niet aansprakelijk. We doen er alles aan om te voorkomen
        dat onze website en de ShoutOuts virussen of andere schadelijke materialen bevatten of verspreiden, maar we kunnen
        hier geen aansprakelijkheid voor aanvaarden. We raden je aan om ervoor te zorgen dat jouw apparaten adequaat zijn
        beveiligd met up-to-date antivirus software en dat je regelmatig een virusscan uitvoert. Iedere ShoutOut wordt met zorg
        gemaakt door de VIP. We zijn niet aansprakelijk voor de inhoud van ShoutOuts.
      </p>
      <p>
        Je blijft te allen tijde zélf verantwoordelijk voor het gebruik van de ShoutOut conform deze Voorwaarden. Bij misbruik van
        een ShoutOut of gebruik van een ShoutOut in strijd met deze Voorwaarden ben je aansprakelijk voor de eventuele schade
        die daaruit voortvloeit.
      </p>
      <p>
        Onze aansprakelijkheid is altijd beperkt (1) tot vergoeding van directe schade en (2) tot maximaal het bedrag dat je ons
        hebt betaald voor de aanschaf van de ShoutOut. Wij zijn nooit aansprakelijk voor indirecte schade of gevolgschade. Deze
        aansprakelijkheidsbeperkingen gelden niet als wij de schade hebben veroorzaakt door opzet of bewuste roekeloosheid.
      </p>
      <h3 class="font-bold pb-2">
        11. Persoonsgegevens
      </h3>
      <p>
        Wij doen er alles aan om jouw persoonsgegevens conform de AVG (de “Algemene Verordening Persoonsgegevens”) te
        verwerken. Op onze website vind je onze privacyverklaring. Daarin kun je precies nalezen wat we met je gegevens doen,
        welke beveiligingsmaatregelen we hebben genomen en wat jouw rechten zijn met betrekking tot jouw
        persoonsgegevens.
      </p>
      <h3 class="font-bold pb-2">
        12. Toepasselijk recht
      </h3>
      <p>
        Op deze Voorwaarden en alle met ons gesloten overeenkomsten is Nederlands recht van toepassing. Mocht sprake zijn
        van een geschil dat we niet in goed overleg met elkaar kunnen oplossen, dan wordt dit geschil voorgelegd aan de
        bevoegde rechter in Amsterdam.
      </p>
      <h3 class="font-bold pb-2">
        13. Tot slot
      </h3>
      <p>
        Jouw vragen, klachten of opmerkingen kun je aan ons voorleggen via e-mail (<a
          class="text-blue underline"
          href="mailto:hi@shoutout.vip"
        >hi@shoutout.vip</a>). We zullen zo snel mogelijk
        reageren op jouw e-mail.
      </p>
    </div>
  </section>
</template>
